/**
 * RoadDisplayField Constants
 * Centralized constants for road display field component
 */

import { Z_INDEX_PANEL_DROPDOWN } from '@/constants/zIndex';

export const ROAD_DISPLAY_FIELD_CONSTANTS = {
  /** Maximum height of the scrollable options dropdown in pixels */
  MAX_DROPDOWN_HEIGHT: 320,

  /** Z-index for the dropdown portal — clears the SlidePanel (z-index 8000) */
  DROPDOWN_Z_INDEX: Z_INDEX_PANEL_DROPDOWN,

  /** IntersectionObserver threshold for the infinite-scroll sentinel */
  LOAD_MORE_THRESHOLD: 0.1,

  /** Icon sizes */
  ICONS: {
    /** Main road icon size */
    ROAD: 16,
    /** GPS action button icon size */
    GPS_ACTION: 16,
    /** Small loader size */
    LOADER_SMALL: 12,
    /** Medium loader size */
    LOADER_MEDIUM: 14,
  },

  /** Badge sizes for road source indicators */
  BADGE: {
    SIZE: 'xs' as const,
  },

  /** Action button sizes */
  ACTION_BUTTON: {
    SIZE: 'sm' as const,
  },
} as const;
